import api from './base/BaseApi';
import { TGetPlaceResponse } from './types/PlaceData';

export const getPlaceById = async (placeId: string) =>
  api.get<TGetPlaceResponse>(`api/v1/places/${placeId}`);
